import { ElementRef, Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
   providedIn: 'root',
})
export class MainService {
   public topbarTemplate$ = new BehaviorSubject<TemplateRef<ElementRef> | null>(null);
   private sidebarStateChanged$ = new BehaviorSubject<boolean>(true);

   constructor() {}

   sideBarToggle() {
      this.sidebarStateChanged$.next(!this.sidebarStateChanged$.value);
   }
}
